module.exports = __webpack_public_path__ + "img/LOGO  1860250-tuya.4df098cb.png";